export const formatNumberAsNumber = (
  num: number,
  maximumFractionDigits = 2,
) => {
  if (isNaN(num)) {
    return 0
  }

  return parseFloat(num.toFixed(maximumFractionDigits))
}
